import { Component, OnInit, Input, ViewChild, ChangeDetectorRef, OnChanges } from '@angular/core';
import { RDMusicElement } from './music-element.class';
import { Howl } from 'howler';
import { RDDarkService } from '../dark.service';

@Component({
  selector: 'rd-music-player',
  template: `<div class="videoContainer" #videoContainer>
  <div id="ytPlayer"></div>
</div>
<div class="wrapper {{color}}Playlist" [class.rdDark]="dark" #playerWrapper *ngIf="localPlaylist.length > 0">
  <div class="controlPanel">
    <div class="namePanel">
      <img [src]="getSongImage(cursor)">
      <span>{{getSongName(cursor)}}</span>
    </div>

    <div class="songController">
      <span (click)="changeSong(-1)"><i class="fas fa-lg fa-angle-left"></i></span>
      <span (click)="changeLectureState()" *ngIf="state === 'play'"><i class="fas fa-pause"></i></span>
      <span (click)="changeLectureState()" *ngIf="state !== 'play'"><i class="fas fa-play"></i></span>
      <span (click)="changeSong(1)"><i class="fas fa-lg fa-angle-right"></i></span>
    </div>

    <div class="songController">
        <span (click)="random = !random;shufflePlaylist()" [class.random]="random"><i class="fas fa-random"></i></span>

        <div class="playlistContainer">
          <span (click)="showPlaylist($event)"><i class="fas fa-th-list"></i></span>
          <div class="playlistMenu" #playlistMenu [style.width.px]="250" [style.maxHeight.px]="150">
            <div *ngFor="let song of localPlaylist; let i = index">
                <span *ngIf="i !== cursor" (click)="$event.stopPropagation();changeSong(i - cursor)">
                  <i class="fas fa-play"></i>
                  {{getSongName(i)}}
                </span>
                <span *ngIf="i === cursor" (click)="$event.stopPropagation();changeSong(0)">
                  <i class="fas fa-pause"></i>
                  {{getSongName(i)}}
                </span>
            </div>
          </div>
        </div>

        <div class="volumeController">
          <span *ngIf="volume === 0" (click)="volume = 50; changeVolume()"><i class="fas fa-volume-off"></i></span>
          <span *ngIf="volume !== 0 && volume < 50" (click)="volume = 0;changeVolume()"><i class="fas fa-volume-down"></i></span>
          <span *ngIf="volume >= 50" (click)="volume = 0;changeVolume()"><i class="fas fa-volume-up"></i></span>
          <div class="slideContainer">
            <input type="range" id="volumeSelector" min="0" max="100" [(ngModel)]="volume" (change)="changeVolume()">
          </div>
        </div>
      </div>
  </div>

  <div class="timeController">
    <span>{{displayTime(currentTime)}}</span>
    <div class="progressBar" #progressBar (click)="changeSeek($event)">
      <div class="innerProgress" [style.width]="getProgress()"></div>
    </div>
    <span>{{displayTime(timeMax)}}</span>
  </div>
</div>
`,
  styles: [`.videoContainer{max-width:100px;display:none}.wrapper{--main-color:#ba9e5a;--text-color:black;--background-color:#f1f1f1;--background-menu:white;display:flex;flex-direction:column;color:var(--text-color)}.wrapper>*{margin:6px}.wrapper.blue-lightPlaylist{--main-color:#5aa2ba}.wrapper.bluePlaylist{--main-color:#5a5aba}.wrapper.greenPlaylist{--main-color:#72ba5a}.wrapper.purplePlaylist{--main-color:#a25aba}.wrapper.redPlaylist{--main-color:#ba5a5a}.wrapper.orangePlaylist{--main-color:#ba8a5a}.wrapper.blackPlaylist{--main-color:black}.wrapper.rdDark{--text-color:white;--background-color:#07384c;--background-menu:#0d2a35}.controlPanel{text-align:center;display:flex;justify-content:space-around;flex-wrap:wrap}.controlPanel .volumeController,.controlPanel>div{display:flex}.controlPanel .namePanel{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.controlPanel .namePanel img{width:25px;height:25px;border-radius:50%;-o-object-fit:cover;object-fit:cover}.controlPanel span{padding:3px 6px}.controlPanel .songController span{cursor:pointer}.controlPanel .random{color:var(--main-color)}.volumeController .slideContainer{opacity:0}.volumeController .slideContainer #volumeSelector{outline:0;cursor:pointer;-webkit-appearance:none;background-color:transparent}.volumeController .slideContainer #volumeSelector::-webkit-slider-runnable-track{-webkit-appearance:none;width:100%;background-color:var(--background-menu)}.volumeController .slideContainer #volumeSelector::-webkit-slider-thumb{-webkit-appearance:none;border:none;border-radius:50%;width:12px;height:12px;background:var(--main-color);cursor:pointer;transition:all .2s ease-in-out}.volumeController .slideContainer #volumeSelector::-webkit-slider-thumb:hover{width:15px;height:15px}.volumeController .slideContainer #volumeSelector::-moz-range-thumb{border:none;border-radius:50%;width:12px;height:12px;background:var(--main-color);cursor:pointer;transition:all .2s ease-in-out}.volumeController .slideContainer #volumeSelector::-moz-range-thumb:hover{width:15px;height:15px}.volumeController:hover .slideContainer{opacity:1}.playlistContainer{position:relative;padding:3px 6px}.playlistContainer .playlistMenu{position:absolute;top:0;right:0;box-shadow:0 2px 5px 0 rgba(0,0,0,.16),0 2px 10px 0 rgba(0,0,0,.12);display:none;background-color:var(--background-menu);text-align:start;overflow-x:hidden;overflow-y:auto}.playlistContainer .playlistMenu div{margin:3px;padding:2px 3px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.playlistContainer .playlistMenu div:not(:last-child){border-bottom:1px solid var(--background-color)}.timeController{display:flex;flex-direction:row}.timeController .progressBar{flex:1;height:12px;margin:0 6px;background-color:var(--background-color);transition:width .1s ease-in-out;cursor:pointer}.timeController .progressBar .innerProgress{background-color:var(--main-color);height:100%}`]
})
export class RDMusicPlayerComponent implements OnInit, OnChanges {

  @Input() playlist: Array<RDMusicElement> = [];
  @Input() color = 'gold';

  @ViewChild('videoContainer') videoContainer;
  @ViewChild('playerWrapper') playerWrapper;
  @ViewChild('playlistMenu') playlistMenu;
  @ViewChild('progressBar') progressBar;

  public localPlaylist: Array<RDMusicElement> = [];
  public cursor = 0;

  public player: any = null;

  public sound: Howl = null;

  public state = 'pause';
  public timeMax = 0;
  public currentTime = 0;

  public random = false;
  public volume = 50;

  public dark = false;

  constructor(private changesDetector: ChangeDetectorRef, private darkService: RDDarkService) { }

  ngOnInit() {
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    window['onYouTubeIframeAPIReady'] = (e) => {
      if (this.playlist.length > 0) {
        this.localPlaylist = this.playlist.slice();
        if (this.currentSongType() === 'youTube') {
          this.initYoutubeVideo(this.localPlaylist[this.cursor]);
        } else {
          this.initFreesoundAudio(this.localPlaylist[this.cursor], false);
        }
      }
    };
    this.darkService.getDarkElement().subscribe(() => {
      this.dark = this.darkService.isDark();
    });
    this.dark = this.darkService.isDark();
  }

  ngOnChanges(changes) {
    if (changes['playlist']) {
      this.localPlaylist = this.playlist.slice();
      if (this.random) {
        this.shufflePlaylist();
      }
    }
  }

  currentSongType() {
    return this.localPlaylist[this.cursor].type;
  }

  initYoutubeVideo(video) {
    this.player = new window['YT'].Player('ytPlayer', {
      videoId: video.url,
      host: 'http://www.youtube.com',
      events: {
        'onStateChange': this.onPlayerStateChange.bind(this),
        'onError': this.onPlayerError.bind(this),
        'onReady': this.onPlayerReady.bind(this)
      }
    });
  }

  onPlayerReady(event) {
    this.player.setVolume(this.volume);
  }

  onPlayerStateChange(event) {
    if (event.data === window['YT'].PlayerState.PLAYING) {
      this.timeMax = Math.round(this.player.getDuration());
      this.state = 'play';
      this.currentTime = Math.round(this.player.getCurrentTime());
      this.changesDetector.detectChanges();
      this.moveSeek();
    } else if (event.data === window['YT'].PlayerState.ENDED) {
      this.state = 'ended';
      this.changeSong(1);
    } else {
      this.state = 'pause';
    }
    this.changesDetector.detectChanges();
  }

  onPlayerError(event) {
    console.log('error', event);
  }

  initFreesoundAudio(audio, autoplay) {
    this.sound = new Howl({
      src: [audio.url],
      volume: this.volume / 100,
      onload: () => {
        this.timeMax = this.sound.duration();
        if (autoplay) {
          this.sound.play();
        }
      },
      onplay: () => {
        this.timeMax = Math.round(this.sound.duration());
        this.state = 'play';
        this.currentTime = Math.round(this.sound.seek());
        this.changesDetector.detectChanges();
        this.moveSeek();
      },
      onend: () => {
        this.state = 'ended';
        this.changeSong(1);
      }
    });
  }

  getSongImage(index) {
    return this.localPlaylist[index].imageurl;
  }

  getSongName(index) {
    return (this.localPlaylist[index].title + ' - ' + this.localPlaylist[index].channel);
  }

  changeLectureState() {
    if (this.currentSongType() === 'youTube') {
      if (this.player) {
        if (this.player.getPlayerState() === window['YT'].PlayerState.PLAYING) {
          this.player.pauseVideo();
          this.state = 'pause';
        } else {
          this.player.playVideo();
        }
      } else {
        this.initYoutubeVideo(this.localPlaylist[this.cursor]);
      }
    } else {
      if (this.sound) {
        if (!this.sound.playing()) {
          this.sound.play();
          this.state = 'play';
        } else {
          this.sound.pause();
          this.state = 'pause';
        }
      } else {
        this.initFreesoundAudio(this.localPlaylist[this.cursor], true);
      }
    }
  }

  moveSeek() {
    const timeInterval = setInterval(() => {
      if (this.state === 'play') {
        if (this.currentSongType() === 'youTube') {
          this.currentTime = Math.round(this.player.getCurrentTime());
        } else {
          this.currentTime = Math.round(this.sound.seek());
        }
        this.changesDetector.detectChanges();
      } else {
        clearInterval(timeInterval);
      }
    }, 1000);
  }

  changeSeek(event) {
    if (this.timeMax !== 0) {
      const percent = (event.clientX - this.progressBar.nativeElement.offsetLeft) / this.progressBar.nativeElement.clientWidth;
      const second = Math.round(this.timeMax * percent);
      this.currentTime = second;
      if (this.currentSongType() === 'youTube') {
        this.player.seekTo(second, true);
      } else {
        this.sound.seek(second);
      }
      this.changesDetector.detectChanges();
    }
  }

  changeSong(index) {
    this.cursor += index;
    this.cursor = (this.cursor >= this.localPlaylist.length) ? (0) : (this.cursor < 0) ? (this.localPlaylist.length - 1) : (this.cursor);
    this.currentTime = null;
    this.timeMax = null;
    if (this.player) {
      this.player.pauseVideo();
    }
    if (this.sound) {
      this.sound.pause();
    }
    if (this.currentSongType() === 'youTube') {
      if (this.player) {
        this.player.loadVideoById(this.localPlaylist[this.cursor].url);
      } else {
        this.initYoutubeVideo(this.localPlaylist[this.cursor]);
        this.player.playVideo();
      }
    } else {
      this.initFreesoundAudio(this.localPlaylist[this.cursor], true);
    }
  }

  shufflePlaylist() {
    if (this.random) {
      const playlist = [];
      playlist.push(this.localPlaylist[this.cursor]);
      this.localPlaylist.splice(this.cursor, 1);
      for (const i = 0; i < this.localPlaylist.length; i) {
        const index = Math.round(Math.random() * (this.localPlaylist.length - 1));
        playlist.push(this.localPlaylist[index]);
        this.localPlaylist.splice(index, 1);
      }
      this.localPlaylist = playlist;
      this.cursor = 0;
    } else {
      let i = 0;
      while (this.localPlaylist[this.cursor] !== this.playlist[i] && i < this.playlist.length) {
        i++;
      }
      this.cursor = (i < this.playlist.length) ? i : 0;
      this.localPlaylist = this.playlist.slice();
    }
  }

  changeVolume() {
    if (this.player) {
      this.player.setVolume(this.volume);
    }
    if (this.sound) {
      this.sound.volume(this.volume / 100);
    }
  }

  showPlaylist(event) {
    this.playlistMenu.nativeElement.style.display = 'block';
    event.stopPropagation();
    this.playerWrapper.nativeElement.onclick = () => {
      this.playlistMenu.nativeElement.style.display = 'none';
      this.playerWrapper.nativeElement.onclick = null;
    };
  }

  getProgress() {
    if (this.currentTime === 0) {
      return '0%';
    }
    return (this.currentTime / this.timeMax) * 100 + '%';
  }

  displayTime(time) {
    if (time) {
      const second = time % 60 < 10 ? '0' + time % 60 : time % 60;
      return (Math.floor(time / 60) + ':' + second);
    } else {
      return '0:00';
    }
  }
}
